module.exports = __webpack_public_path__ + "img/lower flounce length.2d0ae682.png";